export function listStateFromCRUD(crudState) {
  return {
    loading: crudState.loading,
    loadingMore: crudState.loadingMore,
    hasMore: crudState.hasMore,
    filter: crudState.filter,
    items: crudState.items,
    list: crudState.list
  };
}

export function listDispatchFromCrud(dispatch, crudActions) {
  return {
    fetch: (filter) => dispatch(crudActions.fetchList(filter)),
    fetchMore: (filter) => dispatch(crudActions.fetchListMore(filter)),
    delete: (model) => dispatch(crudActions.remove(model)),
  }
}



// WEBPACK FOOTER //
// ./src/selectors/crud.ts